export default __webpack_public_path__ + "static/funcionamiento-icono-3-e6002415deb9d31e41711d1bab68d617.png";